import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

const LEGAL_LINKS = [
  { to: '/help', label: 'Help' },
  { to: '/privacy', label: 'Privacy' },
  { to: '/terms', label: 'Terms' },
];

const linkBaseClassName =
  'inline-flex items-center justify-center min-h-[44px] shrink-0 touch-manipulation px-2 max-lg:min-h-[44px] lg:min-h-8 lg:px-1.5';

const separatorClassName =
  'select-none px-1.5 text-gray-400 dark:text-gray-500 max-lg:px-2';

/**
 * Shared Help · Privacy · Terms nav — consistent separators and 44px tap targets on mobile.
 *
 * @param {{ className?: string, linkClassName?: string }} props
 */
export default function FooterLegalNav({ className, linkClassName }) {
  return (
    <nav
      aria-label="Legal and help"
      className={cn('flex flex-wrap items-center text-ds-caption leading-tight', className)}
    >
      {LEGAL_LINKS.map((item, index) => (
        <React.Fragment key={item.to}>
          {index > 0 ? (
            <span className={separatorClassName} aria-hidden="true">
              ·
            </span>
          ) : null}
          <Link to={item.to} className={cn(linkBaseClassName, linkClassName)}>
            {item.label}
          </Link>
        </React.Fragment>
      ))}
    </nav>
  );
}
